import React from 'react';

import { ReactDataTableTitle } from '@metarouter-private/mr-mui';

const LABEL = 'Schema Enforcement';

export default function SchemaEnforcementTableTitle() {
  return <ReactDataTableTitle label={LABEL} noWrap />;
}
